import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import { AuthState } from "../../../context/auth/auth/reducer";
import { ROUTES } from "../../../routing/routes";
import { useTranslation } from "react-i18next";
import PersonalDataForm from "../../../components/profile/forms/PersonalDataForm";
import CompanyDataForm from "../../../components/profile/forms/CompanyDataForm";
import CfuDataForm from "../../../components/profile/forms/CfuDataForm";
import Button from "../../../components/shared/button/Button";
import { completeUserProfile } from "../../../context/auth/action";
import { COOKIES } from "../../../data/enums";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const CompleteProfileview = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  const history = useHistory();

  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [step, setStep] = useState<string>("personal");

  // Form values (user data)
  const [values, setValues] = useState<any>({});

  // Loading complete profile
  const [loading, setLoading] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const completeProfile = async () => {
    setLoading(true);
    try {
      let updatedUser = await completeUserProfile(user, values);

      openToast({
        type: "success",
        title: "success.general.title",
        message: "success.profile_completed",
        callback: () => {
        },
      });

      dispatch({
        type: "USER_UPDATE",
        payload: updatedUser,
      });
    } catch (err) {
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        callback: () => {
        },
      });
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderPersonalData = (): React.ReactNode => {
    return (
      <>
        <h1 className="h2 text-gray-900 mb-4">
          {t("pages.complete_profile.title", {
            name: user?.firstname,
          })}
        </h1>
        <PersonalDataForm
          user={values}
          onSubmit={(form: any) => {
            setValues({
              ...values,
              ...form,
            });
            setStep("business");
          }}
          pending={false}
          showTitle={false}
          showDesc={false}
        />
      </>
    );
  };

  const renderBusinessData = (): React.ReactNode => {
    return (
      <>
        <h1 className="h2 text-gray-900 mb-4">{t("pages.complete_profile.tell_about_company")}</h1>
        <CompanyDataForm
          user={values}
          onSubmit={(form: any) => {
            setValues({
              ...values,
              ...form,
            });
            setStep("cfu");
          }}
          onCancel={() => {
            setStep("personal");
          }}
          pending={loading}
          showTitle={false}
          showDesc={false}
        />
      </>
    );
  };

  const renderCfuData = (): React.ReactNode => {
    return (
      <>
        <CfuDataForm
          user={values}
          onSubmit={(form: any) => {
            setValues({
              ...values,
              ...form,
            });
            completeProfile();
          }}
          onCancel={() => {
            setStep("business");
          }}
          submitLabel={t("forms.save_and_complete")}
          pending={false}
        />
        <hr/>
        <Button
          disabled={loading}
          loading={loading}
          submit={false}
          onClick={completeProfile}
          className="btn btn-link btn-block"
        >
          {t("forms.skip_and_complete")}
        </Button>
      </>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[CompleteProfileView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[CompleteProfileView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle authorization
   */
  useEffect(() => {
    if (!!user) {
      if (!user.profile_completed) {
        console.log("setting values", user)
        setValues(user);
      } else {
        history.push({ pathname: ROUTES.HOME });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-9">
          <div className="card border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="p-4">
                {(() => {
                  switch (step) {
                    case "personal":
                      return renderPersonalData();
                    case "business": {
                      return renderBusinessData();
                    }
                    case "cfu": {
                      return renderCfuData();
                    }
                    default:
                      return null;
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompleteProfileview;
